import { Component, OnInit } from '@angular/core';
import { DebugService } from '../../../services/debug.service';
@Component({
    selector: 'app-debugcontrols',
    templateUrl: './debugcontrols.component.html',
    styleUrls: ['./debugcontrols.component.scss'],
    standalone: false
})
export class DebugcontrolsComponent implements OnInit {
	constructor(private debugService:DebugService) { 

	}

	ngOnInit() {
	}


	getDebugService():DebugService{
		return this.debugService;
	}

}
